// extracted by mini-css-extract-plugin
module.exports = {"adContainer":"FullscreenScrollAd_adContainer__3k7qL","adContent":"FullscreenScrollAd_adContent__SopHh"};